module.exports = __webpack_public_path__ + "img/genesis-drop-impostor-3.71b4d98a.webp";